<app-page-wrapper>
  <app-loading-spinner *ngIf="!allListItems;else main_content"></app-loading-spinner>

  <ng-template #main_content>
    <h1 class="d-flex">
      Students
    </h1>
    <div class="d-flex justify-content-between mb-3">
      <div class="text-nowrap my-auto">
        <input class="form-control search-input d-inline" (input)="searchValue = searchBox.value;queueSearchTerm(searchBox.value)"
          placeholder="Search" #searchBox id="search-box">
      </div>
    </div>

    <app-loading-spinner *ngIf="searching"></app-loading-spinner>

    <div class="mt-4" *ngIf="searchValue && noMatches">No students found.</div>

    <table class="table" [class.d-none]="searching"> <!-- using ngIf (instead of d-none) here breaks searching -->
      <thead>
        <th>
          <app-sort-toggle columnName="Name">Name</app-sort-toggle>
        </th>
        <th>
          <app-sort-toggle columnName="ID">ID</app-sort-toggle>
        </th>
      </thead>
      <tbody>
        <tr *ngFor="let obj of listItems$ | async" (click)="navTo(obj)">
          <td>
            <div class="d-flex align-items-center">
              <a *ngIf="getRouterLink(obj) !== ''" [routerLink]="getRouterLink(obj)">
                <app-profile-picture class="mr-2" [name]="obj.Name"></app-profile-picture>
                <span>{{ obj.Name }}</span>
              </a>
              <span *ngIf="getRouterLink(obj) === ''">
                <app-profile-picture class="mr-2" [name]="obj.Name"></app-profile-picture>
                <span>{{ obj.Name }}</span>
              </span>
            </div>
          </td>
          <td>
            <span>{{ obj.ExternalID }}</span>
          </td>
        </tr>
      </tbody>
    </table>

  </ng-template>
</app-page-wrapper>
